import React, { Component, Fragment } from 'react'
import { ChromePicker, SketchPicker } from 'react-color'
import style from './ColorPicker.scss'

class ColorPicker extends Component {
  constructor(props) {
    super(props)
    this.state = { displayColorPicker: false }

    this.handleColorChange = this.handleColorChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }
  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
  setWrapperRef(node) {
    this.wrapperRef = node
  }
  handleClick(e) {
    this.setState({
      displayColorPicker: true
    })
  }
  handleClickOutside(e) {
    console.log('handleClickOutside()', e)
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      console.log('You clicked outside of me!')
      this.setState({
        displayColorPicker: false
      })
    }
  }
  handleColorChange(color, event) {
    this.props.updateTheme(this.props.group, this.props.node[0], color.hex)
  }
  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }
  render() {
    return (
      <div ref={this.setWrapperRef} className={style.colorPicker}>
        <span className={style.label}>{this.props.node[0]}</span>
        <div
          ref={node => {
            this.node = node
          }}
        >
          <div className={style.node} onClick={this.handleClick}>
            <span
              className={style.colorSwatch}
              style={{ background: this.props.node[1] }}
            />
            <span className={style.colorLabel}>{this.props.node[1]}</span>

            {this.state.displayColorPicker ? (
              <Fragment>
                <style>
                  {`
                  .${style.SketchPicker} .flexbox-fix:last-of-type {
                    border-top: 1px solid rgba(255, 255, 255, 0.2) !important;
                  }
                  .${style.SketchPicker} span {
                    color: rgba(255, 255, 255, 0.5) !important;
                  }
                  .${style.SketchPicker} input {
                    background: rgba(0,0,0, 0.2) !important;
                    color: #fff !important;
                    border: 1px solid rgba(255, 255, 255, 0.2) !important;
                    box-shadow: none !important;
                  }
                `}
                </style>
                <SketchPicker
                  className={style.SketchPicker}
                  disableAlpha={true}
                  color={this.props.node[1]}
                  onChange={this.handleColorChange}
                />
              </Fragment>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default ColorPicker



// WEBPACK FOOTER //
// ./src/components/ColorPicker/ColorPicker.js